import mainAuth0Client from './mainAuth0Client'
import { REACT_APP_AUTH0_CLIENT_ID, REACT_APP_AUTH0_DOMAIN } from '../config/runtimeEnv'

const initializeClients = async () => {
  const tasks = []
  if (REACT_APP_AUTH0_DOMAIN && REACT_APP_AUTH0_CLIENT_ID) {
    tasks.push(mainAuth0Client.init())
  }
  await Promise.all(tasks)
}

export default initializeClients
